<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc">Contents</h2>
<p class="firstverse"><br/></p>
<p class="firstverse"><a href="#/Text/Preface">Preface</a></p>
<p class="firstverse"><a href="#/Text/PartOne">Part One   The Me-Centered Self</a></p>
<p class="firstverse"><a href="#/Text/Chap1">1: How the Me-Centered World Was Born</a></p>
<p class="firstverse"><span href="#/Text/chap2" title="Link target outside of Sample">2: Defiance</span></p>
<p class="firstverse"><span href="#/Text/chap3" title="Link target outside of Sample">3: Subservience</span></p>
<p class="firstverse"><span href="#/Text/chap4" title="Link target outside of Sample">4: Indifference</span></p>
<p class="firstverse"><span href="#/Text/chap5" title="Link target outside of Sample">5: The God of the Modern Self</span></p>
<p class="firstverse"><span href="#/Text/chap6" title="Link target outside of Sample">6: The Secret Aspirations of the Modern Self</span></p>
<p class="firstverse"><span href="#/Text/chap7" title="Link target outside of Sample">7: Some Unwelcome Limits on Freedom and Dignity</span></p>
<p class="firstverse"><span href="#/Text/PartTwo" title="Link target outside of Sample">Part Two   The God-Centered Self</span></p>
<p class="firstverse"><span href="#/Text/chap8" title="Link target outside of Sample">8: The Self-Giving God of the Gospel</span></p>
<p class="firstverse"><span href="#/Text/chap9" title="Link target outside of Sample">9: The Irony of Divine “Weakness”</span></p>
<p class="firstverse"><span href="#/Text/chap10" title="Link target outside of Sample">10: The Awakening Presence</span></p>
<p class="firstverse"><span href="#/Text/chap11" title="Link target outside of Sample">11: A New Way of Being Human Being</span></p>
<p class="firstverse"><span href="#/Text/chap12" title="Link target outside of Sample">12: The Divine Adoption</span></p>
<p class="firstverse"><span href="#/Text/chap13" title="Link target outside of Sample">13: The Emergence of God-Centered Identity</span></p>
<p class="firstverse"><span href="#/Text/chap14" title="Link target outside of Sample">14: The Freedom of the Children of God</span></p>
<p class="firstverse"><span href="#/Text/chap15" title="Link target outside of Sample">15: God’s Love as the Ground and Measure of Human Dignity</span></p>
<p class="firstverse"><span href="#/Text/chap16" title="Link target outside of Sample">16: The Reconciliation of Heaven and Earth</span></p>
<p class="firstverse"><span href="#/Text/SubjectIndex" title="Link target outside of Sample">Subject Index</span></p>
<p class="firstverse"><span href="#/Text/ScriptureIndex" title="Link target outside of Sample">Scripture Index</span></p>
<p class="firstverse"><span href="#/Text/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="firstverse"><span href="#/Text/author" title="Link target outside of Sample">About the Author</span></p>
<p class="firstverse"><span href="#/Text/Endorsements" title="Link target outside of Sample">Endorsements</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6b4a32ea